import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { LtiVersion } from '@ublend-npm/aula-schema';
import { selectors as coreSelectorsProviders } from '$data/providers';
import { selectors as coreSelectors } from '$data/core';

import Lti1p3Form from './Lti1p3Form';
import lti1p3Start from './lti1p3Start';
import LtiRequestType from './types';

const Lti1p3Launch = ({
  providerId,
  resourceLinkId,
  resourceLinkTitle,
  assignmentId,
  assignmentFormData,
  onSuccessLaunch,
  onErrorLaunch,
}) => {
  const user = useSelector(coreSelectors.getUser);
  const spaceId = useSelector(coreSelectors.getCurrentSpaceId);
  const ltiProviders = useSelector(coreSelectorsProviders.getProvidersById);

  const [ltiSessionToken, setLtiSessionToken] = useState();
  const [shouldLaunch, setShouldLaunch] = useState(true);

  const formRef = useRef(null);

  const { id: userId } = user || {};
  let provider = ltiProviders[providerId];

  if (
    !provider ||
    provider.ltiVersion !== LtiVersion.ONE_POINT_THREE ||
    provider.disabled
  ) {
    provider = null;
  }

  const { loginUrl, targetUrl, iss, clientId, isDeepLinking } = provider || {};
  const type = isDeepLinking
    ? LtiRequestType.DEEP_LINKING
    : LtiRequestType.RESOURCE_LINK;

  useEffect(() => {
    if (shouldLaunch && !ltiSessionToken && userId && clientId) {
      lti1p3Start({
        spaceId,
        clientId,
        type,
        userId,
        resourceLinkId,
        ...(resourceLinkTitle ? { resourceLinkTitle } : {}),
        ...(assignmentId ? { assignmentId } : {}),
        ...(assignmentFormData ? { assignmentFormData } : {}),
      })
        .then((ltiToken) => {
          setLtiSessionToken(ltiToken);
        })
        .catch((err) => {
          onErrorLaunch(err);
        });
    }
  }, [
    shouldLaunch,
    ltiSessionToken,
    userId,
    spaceId,
    clientId,
    type,
    resourceLinkId,
  ]);

  useEffect(() => {
    if (formRef.current && shouldLaunch && ltiSessionToken && clientId) {
      // eslint-disable-next-line no-unused-expressions
      formRef.current.requestSubmit();
      onSuccessLaunch();
      setLtiSessionToken(undefined);
      setShouldLaunch(false);
    }
  }, [shouldLaunch, ltiSessionToken, clientId]);

  if (
    shouldLaunch &&
    ltiSessionToken &&
    clientId &&
    loginUrl &&
    targetUrl &&
    iss
  ) {
    return (
      <Lti1p3Form
        ref={formRef}
        loginUrl={loginUrl}
        targetUrl={targetUrl}
        clientId={clientId}
        iss={iss}
        type={
          isDeepLinking
            ? LtiRequestType.DEEP_LINKING
            : LtiRequestType.RESOURCE_LINK
        }
        loginHint={ltiSessionToken}
        target="_blank"
      />
    );
  }

  return null;
};

export default Lti1p3Launch;
